module.exports = __webpack_public_path__ + "static/media/5_The Cracked pot_FA.a4a48d45.txt";